var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"szycarousel"},[_c('el-carousel',{class:{ isMobile: _vm.isMobile },attrs:{"interval":7000}},_vm._l((_vm.silderList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":_vm.baseUrl + item.thumb,"alt":""},on:{"click":function($event){return _vm.showBusiness(item)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }